//used in OOKA STORE(pdp , plp , related , upsell etc)
export const StoreAttributes = ``
